var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Action button"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.10391,
    y: 0.885156,
    width: 22.8,
    height: 22.8,
    rx: 2.4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1927 10.3679C20.1927 10.0542 20.068 9.75333 19.8462 9.53152C19.6244 9.3097 19.3236 9.18509 19.0099 9.18509H16.6443V6.81951C16.6443 6.50581 16.5197 6.20497 16.2979 5.98315C16.076 5.76133 15.7752 5.63672 15.4615 5.63672H5.9992C5.6855 5.63672 5.38465 5.76133 5.16284 5.98315C4.94102 6.20497 4.81641 6.50581 4.81641 6.81951V16.2818C4.81675 16.3931 4.84848 16.502 4.90794 16.596C4.9674 16.6901 5.05218 16.7654 5.15255 16.8134C5.25292 16.8615 5.36479 16.8802 5.47533 16.8675C5.58586 16.8548 5.69057 16.8112 5.77742 16.7416L8.36477 14.6555V16.8732C8.36477 17.1869 8.48939 17.4878 8.7112 17.7096C8.93302 17.9314 9.23387 18.056 9.54756 18.056H16.4661L19.2316 20.29C19.3363 20.3746 19.4667 20.4211 19.6013 20.4216C19.7581 20.4216 19.9085 20.3593 20.0194 20.2484C20.1304 20.1375 20.1927 19.987 20.1927 19.8302V10.3679ZM17.0472 17.0048C16.9425 16.9202 16.8122 16.8737 16.6776 16.8732H9.54756V14.5076H15.4615C15.7752 14.5076 16.076 14.383 16.2979 14.1612C16.5197 13.9394 16.6443 13.6385 16.6443 13.3248V10.3679H19.0099V18.592L17.0472 17.0048Z",
    fill: "#0B6D76"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.10391,
    y: 0.885156,
    width: 22.8,
    height: 22.8,
    rx: 2.4,
    stroke: "#0B6D76",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatButton);
export default __webpack_public_path__ + "static/media/Chat_button.d54bcb679512106cd0bf270a1d02226e.svg";
export { ForwardRef as ReactComponent };